<template>
  <Layout>
    <div class="row">
      <div class="col-12" >
        <div class="d-flex justify-content-between">
          <h4>Welcome <b class="text-success h5">{{ userData.first_name }} {{ userData.last_name }}</b></h4>
          {{ new Date().toLocaleDateString('en-US', options) }}
        </div>

        <div class="card shadow-lg">
          <div class="card-body">  
            <b-tabs pills justified content-class="mt-4 text-success"  active-nav-item-class="text-uppercase text-black">
              <b-tab active class="border-0">
                <template v-slot:title><i class="mdi mdi-apps"></i> Dashboard</template>
                <div class="row">
                  <div class="col-md-4" v-if="this.user_type==2">
                  <div class="card shadow-lg">
                  <div class="card-body">
                    <div class="media">
                      <div class="media-body ms-4">
                        <h4 class="text-danger fw-medium mb-2">Pending Bookings</h4>
                        <p class="mb-0">{{pending}}</p>
                      </div>
                      <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-danger">
                        <span class="avatar-title"><span class="font-size-24"> <i class="mdi mdi-book"></i> </span></span>
                      </div>
                    </div>
                  </div>
                  </div>
                  <div class="card shadow-lg">
                  <div class="card-body">
                    <div class="media">
                      <div class="media-body ms-4">
                        <h4 class="text-danger fw-medium mb-2">Completed Bookings</h4>
                        <p class="mb-0">{{completed}}</p>
                      </div>
                      <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-danger">
                        <span class="avatar-title"><span class="font-size-24"> <i class="mdi mdi-check-circle"></i> </span></span>
                      </div>
                    </div>
                  </div>
                  </div>
                  <div class="card shadow-lg">
                  <div class="card-body">
                    <div class="media">
                      <div class="media-body ms-4">
                        <h4 class="text-danger fw-medium mb-2">Services</h4>
                        <p class="mb-0">{{ myproduct }}</p>
                      </div>
                      <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-danger">
                        <span class="avatar-title"><span class="font-size-24"> <i class="mdi mdi-message-reply-text"></i> </span></span>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
              <div class="col-md-8">
                <FullCalendar :options="calendarOptions" />
              </div>
            </div>
              </b-tab>
              <b-tab v-if="this.user_type==2">
                <template v-slot:title><i class="fas fa-box"></i> Services</template>
                <div class="mb-2 float-end">
                  <b-button v-b-modal.new-service size="sm" variant="success"><i class="mdi mdi-plus"></i> New Service</b-button>
                </div>
                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                      <label class="d-inline-flex align-items-center">
                        Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="table-responsive">
                  <b-table
                    :items="fetchedservices"
                    :fields="['#','service_id','photo','name','price','description','created_at','actions']"
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    @filtered="Filtered"
                    :busy="IsBusy"
                  >
                  <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                  <template #cell(#)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(photo)="data">
                    <img :src="getFiles(data.item.photo)" height="50"/>
                  </template>
                  <template #cell(service_id)="data">
                      {{ (data.item.product_id) }}
                  </template>
                  <template #cell(price)="data">
                      {{ commas(data.item.price) }}
                  </template>
                  <template #cell(created_at)="data">
                      {{ new Date(data.item.created_at).toLocaleDateString('en-US', options) }}
                  </template>
                  <template #cell(actions)="data">
                    <div class="btn-group">
                      <b-button @click="edit(data.item.id,data.item.name,data.item.price,data.item.category.id,data.item.description,data.item.photo)" type="button" class="btn-sm btn" variant="info"  v-b-modal.delete> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                      <b-button @click="remove(data.item.id,data.item.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                    </div>
                  </template>
                  </b-table>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="dataTables_paginate paging_simple_numbers float-end">
                      <ul class="pagination pagination-rounded mb-0">
                        <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>                 
              </b-tab>
                <b-tab v-if="this.user_type==2">
                <template v-slot:title><i class="fas fa-shopping-cart"></i> Products</template>
                <div class="mb-2 float-end">
                  <b-button v-b-modal.new-product size="sm" variant="success"><i class="mdi mdi-plus"></i> New Product</b-button>
                </div>
                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage10" size="sm" :options="Options10"></b-form-select> entries
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                      <label class="d-inline-flex align-items-center">
                        Search: <b-form-input v-model="filter10" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="table-responsive">
                  <b-table
                    :items="fetchedproducts"
                    :fields="['#','product_id','photo','name','price','description','created_at','actions']"
                    responsive="sm"
                    :per-page="perPage10"
                    :current-page="currentPage10"
                    :filter="filter10"
                    :filter-included-fields="filterOn10"
                    @filtered="Filtered10"
                    :busy="IsBusy"
                  >
                  <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                  <template #cell(#)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(photo)="data">
                    <img :src="getFiles(data.item.photo)" height="50"/>
                  </template>
                  <template #cell(product_id)="data">
                      {{ (data.item.product_id) }}
                  </template>
                  <template #cell(price)="data">
                      {{ commas(data.item.price) }}
                  </template>
                  <template #cell(created_at)="data">
                      {{ new Date(data.item.created_at).toLocaleDateString('en-US', options) }}
                  </template>
                  <template #cell(actions)="data">
                    <div class="btn-group">
                      <b-button @click="edit(data.item.id,data.item.name,data.item.price,data.item.category.id,data.item.description,data.item.photo)" type="button" class="btn-sm btn" variant="info"  v-b-modal.delete> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                      <b-button @click="remove(data.item.id,data.item.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                    </div>
                  </template>
                  </b-table>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="dataTables_paginate paging_simple_numbers float-end">
                      <ul class="pagination pagination-rounded mb-0">
                        <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>                 
                </b-tab>
              <b-tab>
                <template v-slot:title><i class="fas fa-tasks"></i> Bookings</template>
                <div v-if="this.user_type==2">
                <div class="card shadow-lg">
                  <div class="card-body">
                    <div class="card-header h4">My Orders</div>
                  <div class="row">
                    <div class="col-sm-12 col-md-6">
                      <div id="tickets-table_length" class="dataTables_length">
                        <label class="d-inline-flex align-items-center">
                          Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage1" size="sm" :options="Options1"></b-form-select> entries
                        </label>
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-6">
                      <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                        <label class="d-inline-flex align-items-center">
                          Search: <b-form-input v-model="filter1" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="table-responsive">
                    <b-table
                      :items="orders"
                      :fields="['#','photo','product','cost','client','created','approved','actions']"
                      responsive="sm"
                      :per-page="perPage1"
                      :current-page="currentPage1"
                      :filter="filter1"
                      :filter-included-fields="filterOn1"
                      @filtered="Filtered1"
                    >
                    <template #cell(#)="data"> {{ data.index + 1 }} </template>
                    <template #cell(photo)="data"><img :src="getFiles(data.item.product.photo)" height="50"/><br>  <small>#{{ data.item.order_id }}</small></template>
                    <template #cell(client)="data">{{ data.item.client.first_name}} {{ data.item.client.last_name}} <br>  <small>{{ data.item.client.address }} {{ data.item.client.contact }}</small></template>
                    <template #cell(product)="data">{{ data.item.product.name }} <br> <small>{{ commas(data.item.product.price) }}</small></template>
                    <template #cell(created)="data"> {{ data.item.added_at }}</template>
                    <template #cell(cost)="data"> {{ commas(data.item.product.price*data.item.quantity) }}</template>
                    <template #cell(approved)="data">
                        <span class="small text-warning" v-if="data.item.status==1 && data.item.vendor.user_id==userData.user_id"> <i class="mdi mdi-circle"></i> Pending </span>
                        <span v-else class="small"> Venue : <b>{{ data.item.approvedvenue }}</b> <br> Date : <b>{{ data.item.approveddate }}</b> <br> Time : <b>{{ data.item.approvedtime }}</b> </span>  
                    </template>
                    <template #cell(actions)="data">
                      <span v-if="data.item.paystatus">
                      <div class="btn-group">
                        <b-button v-if="data.item.status==1 && data.item.vendor.user_id==userData.user_id" @click="approve(data.item.id,data.item.order_id,data.item.client.first_name)" type="button" class="btn-sm btn" variant="primary"> <i class="mdi mdi-check-circle"></i> Approve </b-button>
                        <b-button v-else type="button" class="btn-sm btn" variant="dark"> <i class="mdi mdi-check"></i> Approved </b-button>
                      </div>
                      </span>
                      <span v-else class="small text-danger"> <i class="mdi mdi-close-circle"></i> Not Paid </span>
                    </template>
                    </b-table>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="dataTables_paginate paging_simple_numbers float-end">
                        <ul class="pagination pagination-rounded mb-0">
                          <b-pagination v-model="currentPage1" :total-rows="List1" :per-page="perPage1"></b-pagination>
                        </ul>
                      </div>
                    </div>
                  </div> 
                  </div> 
                </div> 
                </div>
                
                <div class="card shadow-lg">
                  <div class="card-body">
                    <div class="card-header h4">My Bookings</div>
                  <div class="row">
                    <div class="col-sm-12 col-md-6">
                      <div id="tickets-table_length" class="dataTables_length">
                        <label class="d-inline-flex align-items-center">
                          Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage2" size="sm" :options="Options2"></b-form-select> entries
                        </label>
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-6">
                      <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                        <label class="d-inline-flex align-items-center">
                          Search: <b-form-input v-model="filter2" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="table-responsive">
                    <b-table
                      :items="bookings"
                      :fields="['#','photo','product','cost','vendor','created_at','actions']"
                      responsive="sm"
                      :per-page="perPage2"
                      :current-page="currentPage2"
                      :filter="filter2"
                      :filter-included-fields="filterOn2"
                      @filtered="Filtered2"
                    >
                    <template #cell(#)="data"> {{ data.index + 1 }} </template>
                    <template #cell(photo)="data"><img :src="getFiles(data.item.product.photo)" height="50"/><br>  <small>#{{ data.item.order_id }}</small></template>
                    <template #cell(vendor)="data">{{ data.item.vendor.first_name}} {{ data.item.vendor.last_name}} <br>  <small>{{ data.item.vendor.address }} {{ data.item.vendor.contact }}</small></template>
                    <template #cell(product)="data">{{ data.item.product.name }} <br> <small>{{ commas(data.item.product.price) }}</small></template>
                    <template #cell(created_at)="data"> {{ data.item.added_at }}</template>
                    <template #cell(cost)="data"> {{ commas(data.item.product.price*data.item.quantity) }}</template>
                    <template #cell(actions)="data">
                      <div class="btn-group">
                        <b-button v-if="data.item.status==1" type="button" class="btn-sm btn" variant="info"> <i class="mdi mdi-square-edit-outline"></i> Pending</b-button>
                        <b-button v-else type="button" class="btn-sm btn" variant="dark"> <i class="mdi mdi-check-"></i> Completed </b-button>
                        <router-link :to="{ path: '/print', query: { id: data.item.id }}" type="button" class="btn-sm btn btn-primary"> <i class="fas fa-print"></i> Reciept</router-link>
                      </div>
                    </template>
                    </b-table>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="dataTables_paginate paging_simple_numbers float-end">
                        <ul class="pagination pagination-rounded mb-0">
                          <b-pagination v-model="currentPage2" :total-rows="List2" :per-page="perPage2"></b-pagination>
                        </ul>
                      </div>
                    </div>
                  </div>                   
                </div>
                </div>
              </b-tab>
              <b-tab>
                <template v-slot:title><i class="fas fa-user-circle"></i> Account Details</template>
                <b-form class="p-1" @submit.prevent="savePersonalData">
                  <div class="row">
                  <div class="col-md-6 mb-1">
                    <label>Full Name</label> <small class="text-warning">*</small>
                    <input type="text" required v-model="first_name" class="form-control"  placeholder="Enter First Name" />
                  </div>
                  <div class="col-md-6 mb-1">
                    <label>last Name</label> <small class="text-warning">*</small>
                    <input type="text" required v-model="last_name" class="form-control"  placeholder="Enter Last Name" />
                  </div>
                  <div class="col-md-6 mb-1">
                      <label>Gender</label> <small class="text-warning">*</small>
                      <select class="form-control" v-model="gender">
                        <option>Female</option>
                        <option>Male</option>
                      </select>
                    </div>
                  <div class="col-md-6 mb-1">
                    <label>Telephone</label> <small class="text-warning">*</small>
                    <input type="number" required v-model="telephone" class="form-control" placeholder="Enter Telephone" />
                  </div>
                  <div class="col-md-6 mb-1">
                    <label>Town / City</label> <small class="text-warning">*</small>
                    <input type="text" required v-model="address" class="form-control" placeholder="Enter Address" />
                  </div>
                  <div class="col-md-6 mb-1">
                    <label>Email</label> <small class="text-warning">*</small>
                    <input type="email" required v-model="email" class="form-control" placeholder="Enter Email Address" />
                  </div>
                  <div class="col-md-6">
                    <b-form-group label="Account Type">
                      <b-form-radio-group id="btn-radios-1" v-model="user_type" :options="usertypeoptions" button-variant="outline-danger" size="sm" name="radios-btn-default" buttons></b-form-radio-group>
                    </b-form-group>
                  </div>
                  <div v-show="user_type==2" class="row">
                  <div class="col-md-6">
                    <label>Business Name</label>
                    <input type="text" v-model="businessname" class="form-control" placeholder="Business Name" />
                  </div>
                  <div class="col-md-6">
                    <label>Business Address</label> <small class="text-warning">*</small>
                    <input type="text" v-model="businessaddress" class="form-control" placeholder="Business Address" />
                  </div>
                  <div class="col-md-6">
                    <label>Business Telephone</label>
                    <input type="numeber" v-model="businesstelephone" class="form-control" placeholder="Telephone"/>
                  </div>
                  <div class="col-md-6">
                    <label>Business Logo</label> <small class="text-warning">*</small>
                    <div class="row">
                    <div class="col-10"><input type="file" v-on:change="onLogoChange" accept=".jpg,.png,.jpeg" class="form-control"/></div>
                    <div class="col-2"><img :src="getLogo(businesslogo)" height="50" class="rounded-circle"/></div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <label>Business Description</label>
                    <tinymce id="d1" v-model="businessdescription"></tinymce>
                  </div>
                  </div>
                  <div class="col-md-6"><br>
                    <b-button type="submit" class="w-100" variant="danger">Update</b-button>
                  </div>
                  </div>
                </b-form>
              </b-tab>
            </b-tabs>
          </div>
        </div>
    </div>
  </div>
 
    <b-modal id="new-product" centered title="New Product" title-class="font-18" hide-footer>
      <form @submit.prevent="addProduct">
        <div class="form-group mb-2">
        <label>Product Name</label>
        <input v-model="productname" type="text" class="form-control" />
        <label>Price</label>
        <input v-model="productprice" type="number" class="form-control" />
        <label>Category</label>
        <b-form-select v-model="category" required :options="fetchedsubcategories" class="mb-3 form-control" value-field="id" text-field="name"></b-form-select>
        <label>Description</label>
        <textarea v-model="productdescrption" class="form-control"></textarea>
        <label>Featured Image</label> <small class="text-warning">*</small>
        <input type="file" v-on:change="onImageChange" class="form-control" accept=".jpg,.png,.jpeg"/>
        <span class="text-info small">Preferred Dimensions 200 x 200 </span>
        </div>
        <div class="form-group d-flex justify-content-end">
            <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-product')" >Cancel</b-button>
            <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="new-service" centered title="New Service" title-class="font-18" hide-footer>
      <form @submit.prevent="addService">
        <div class="form-group mb-2">
        <label>Service Name</label>
        <input v-model="productname" type="text" class="form-control" />
        <label>Price</label>
        <input v-model="productprice" type="number" class="form-control" />
        <label>Category</label>
        <b-form-select v-model="category" required :options="fetchedsubcategories" class="mb-3 form-control" value-field="id" text-field="name"></b-form-select>
        <label>Description</label>
        <textarea v-model="productdescrption" class="form-control"></textarea>
        <label>Featured Image</label> <small class="text-warning">*</small>
        <input type="file" v-on:change="onImageChange" class="form-control" accept=".jpg,.png,.jpeg"/>
        <span class="text-info small">Preferred Dimensions 200 x 200 </span>
        </div>
        <div class="form-group d-flex justify-content-end">
            <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-service')" >Cancel</b-button>
            <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
        </div>
      </form>
    </b-modal>
  
    <b-modal id="edit-product" centered title="Edit Service" title-class="font-14" hide-footer>
      <form @submit.prevent="editProduct">
        <div class="form-group mb-2">
        <input v-model="id" type="hidden">
        <label>Service Name</label>
        <input v-model="productname" type="text" class="form-control" />
        <label>Price</label>
        <input v-model="productprice" type="number" class="form-control" />
        <label>Category</label>
        <b-form-select v-model="category" required :options="fetchedsubcategories" class="mb-3 form-control" value-field="id" text-field="name"></b-form-select>
        <label>Description</label>
        <textarea v-model="productdescrption" class="form-control"></textarea>
        <div class="row">
          <div class="col-9">
          <label>Featured Image</label> <small class="text-warning">*</small>
          <input type="file" v-on:change="onImageChange" class="form-control" accept=".jpg,.png,.jpeg"/>
        </div>
        <div class="col-3 "><br>
          <img :src="getFiles(oldphoto)" height="50"/>
        </div>
        </div>
        <span class="text-info small">Preferred Dimensions 200 x 200 </span>
        </div>
        <div class="form-group d-flex justify-content-end">
            <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-product')" >Cancel</b-button>
            <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="delete-product" centered title="Delete Service" title-class="font-12" hide-footer>
      <form @submit.prevent="removeProduct">
        <input v-model="id" type="hidden">
          Are you sure you want to delete the Service : <b>{{ productname }}</b> ?
        <div class="form-group d-flex justify-content-end">
            <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-product')" >Cancel</b-button>
            <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
        </div>
      </form>
    </b-modal>
    
    <b-modal id="event-details" centered title="Event Details" title-class="font-12" hide-footer>
       <span v-html="eventdescription"></span>        
    </b-modal>
    
    <b-modal id="approve-order" centered title="Complete Order" title-class="font-12" hide-footer>
      <form @submit.prevent="approveOrder">
        <input v-model="order_id" type="hidden">
          Mark Order <b>{{ order_id }}</b> as Completed for Client <b>{{ client_name }}</b><br> <br>
          
        <label>Appointment Date</label>
        <input v-model="approveddate" type="date" class="form-control" />
        
        <label>Appointment Time</label>
        <input v-model="approvedtime" type="time" class="form-control" />
        
        <label>Appointment Venue</label>
        <input v-model="approvedvenue" type="text" class="form-control" />
        <div class="form-group d-flex justify-content-end mt-2">
            <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('approve-order')" >Cancel</b-button>
            <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
// import {FlutterwavePayButton} from "flutterwave-vue-v3"
// import Multiselect from "vue-multiselect";
import { countriesMethods, countriesComputed, categorieMethods, categorieComputed,} from "@/state/helpers";

export default {
  page: {
    title: "Home",
    meta: [{name: "description",content: appConfig.description}],
  },
  components: { Layout,FullCalendar },
  data() {
    return {
    userData: JSON.parse(localStorage.getItem("user")),
    options : { weekday: "long", year: "numeric", month: "long", day: "numeric",},
    currentdate:new Date().toLocaleDateString('fr-CA'),
    first_name:'', last_name:'', email:'', telephone:'', nationality:'', address:'', user_type:'', gender:'',
    businessname:'',businesstelephone:'',businessdescription:'',businessaddress:'',businesslogo:'',newbusinesslogo:'', oldphoto:'',
    id:"", productname:"",productprice:"", category:"", productdescrption:"", productimage:"", producttype:"",  fetchedproducts:[], fetchedservices:[],
    TotalRows: 1, currentPage: 1, perPage: 10, Options: [10, 50, 100, 150, 200], filter: null, filterOn: [], sortDesc: true, isBusy: true,
    TotalRows1: 1, currentPage1: 1, perPage1: 10, Options1: [10, 50, 100, 150, 200], filter1: null, filterOn1: [], sortDesc1: true, isBusy1: true,
    TotalRows10: 1, currentPage10: 1, perPage10: 10, Options10: [10, 50, 100, 150, 200], filter10: null, filterOn10: [], sortDesc10: true, isBusy10: true,
    TotalRows2: 1, currentPage2: 1, perPage2: 10, Options2: [10, 50, 100, 150, 200], filter2: null, filterOn2: [], sortDesc2: true, isBusy2: true,
    usertypeoptions: [{ text: ' Personal', value: '1' },{ text: ' Vendor', value: '2' },],
    orders:[], bookings:[], orderid:'', order_id:'', client_name:'', approveddate:'', approvedtime:"00:00", approvedvenue:"",
    myproduct:0,completed:0,pending:0,
    fetchedsubcategories:[], eventdescription:"",
    showCalendar: true,
    calendarOptions: {
        eventClick: (info) => {
          this.clickedEvent(info);
        },
        plugins: [dayGridPlugin, timeGridPlugin, listPlugin],
        eventDisplay: "popover",
        initialView: "dayGridMonth",
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
        },
        events: [],
        eventColor: "#564ab1",
        firstDay: 1,
      },
    };
  },
  computed: {
    ...countriesComputed,
    ...categorieComputed,
    List() { return this.fetchedservices.length; },
    List10() { return this.fetchedproducts.length; },
    List1() { return this.fetchOrders.length; },
    List2() { return this.bookings.length; },
    IsBusy() { let a=false; if (this.fetchedservices.length>0) { a=false;} else { a=true;} return a },
    IsBusy10() { let a=false; if (this.fetchedproducts.length>0) { a=false;} else { a=true;} return a },
  },
  created() {
    this.fetchCountries();
    this.fetchData();
    this.fetchProducts();
    this.fetchServices();
    this.fetchOrders();
    this.fetchBookings();
    this.fetchSubCategories();
    this.fetchDashboard();
    this.TotalRows = this.fetchedproducts.length;
    this.TotalRows1 = this.orders.length;
    this.TotalRows10 = this.fetchedservices.length;
    this.TotalRows2 = this.bookings.length;
    this.isBusy=false;
  },
  methods: {
    ...countriesMethods,
    ...categorieMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    Filtered1(filteredItems1) {
      this.TotalRows1 = filteredItems1.length;
      this.currentPage1 = 1;
    },
    Filtered10(filteredItems10) {
      this.TotalRows10 = filteredItems10.length;
      this.currentPage10 = 1;
    },
    Filtered2(filteredItems2) {
      this.TotalRows2 = filteredItems2.length;
      this.currentPage2 = 1;
    },
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    onLogoChange(e){ this.newbusinesslogo = e.target.files[0]; },
    onImageChange(e){ this.productimage = e.target.files[0]; },
    getFiles(name){
      let url = axios.defaults.baseURL;
      let imagelink = (url).slice(0,-3)+"products/"+name;
      return imagelink;
    },
    getLogo(name){
      let url = axios.defaults.baseURL;
      let imagelink = (url).slice(0,-3)+"logos/"+name;
      return imagelink;
    },
    edit(id,name,price,category,description,photo){
        this.id=id;
        this.productname=name;
        this.productprice=price;
        this.category=category;
        this.productdescrption=description;
        this.oldphoto=photo;
        this.$bvModal.show('edit-product')
      },
    remove(id,name){
        this.id=id;
        this.productname=name;
        this.$bvModal.show('delete-product')
      },
    clickedEvent(info){
      this.eventdescription=info.event.title;
      this.$bvModal.show('event-details')
    },
    approve(orderid,order_id,client_name){
      this.orderid=orderid;
      this.order_id=order_id;
      this.client_name=client_name;
      this.$bvModal.show('approve-order')
    },
    async fetchDashboard() { 
      let url = "/fetchdashboard";
      await axios.get(url).then((response) => {
      if (response.status == 200) {
          this.myproduct=response.data.products;
          this.completed=response.data.completed;
          this.pending=response.data.pending;
      }
    });
    },
      async fetchData() { 
      let url = "/fetchdata";
      await axios.get(url).then((response) => {
      if (response.status == 200) {
          this.first_name=response.data.first_name;
          this.last_name=response.data.last_name;
          this.telephone=response.data.contact;
          this.email=response.data.email;
          this.gender=response.data.gender;
          this.address=response.data.address;
          this.user_type= response.data.user_type;
          this.businessname= response.data.business_name;
          this.businessaddress= response.data.business_address;
          this.businesstelephone= response.data.business_contact;
          this.businessdescription= response.data.description;
          this.businesslogo= response.data.logo;
      }
      });
    },
    async savePersonalData() { 
      let formData = new FormData();
      formData.append("first_name", this.first_name);
      formData.append("last_name", this.last_name);
      formData.append("contact", this.telephone);
      formData.append("email", this.email);
      formData.append("gender", this.gender);
      formData.append("address", this.address);
      formData.append("user_type", this.user_type);
      formData.append("businessname", this.businessname);
      formData.append("businessaddress", this.businessaddress);
      formData.append("businesstelephone", this.businesstelephone);
      formData.append("businesslogo", this.newbusinesslogo);
      formData.append("description", this.businessdescription);
      formData.append("longitude", JSON.parse(localStorage.getItem("coordinates")).lng);
      formData.append("latitude", JSON.parse(localStorage.getItem("coordinates")).lat);
      let url = "/savepersonaldata";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchData();
       }
      });
    },
    async fetchProducts() { 
      let url = "/fetchproducts";
      await axios.get(url).then((response) => {
      if (response.status == 200) {
        this.fetchedproducts=response.data.products;
      }
    })
    },
    async fetchServices() { 
      let url = "/fetchservices";
      await axios.get(url).then((response) => {
      if (response.status == 200) {
        this.fetchedservices=response.data.services;
      }
    })
    },
    async fetchSubCategories() { 
      let url = "/fetchsubcategories";
      await axios.get(url).then((response) => {
      if (response.status == 200) {
        this.fetchedsubcategories=response.data.subcategories;
      }
    })
    },
    async addProduct(){
      let formData = new FormData();
      formData.append("name", this.productname);
      formData.append("price", this.productprice);
      formData.append("category", this.category);
      formData.append("description", this.productdescrption);
      formData.append("image", this.productimage);
      formData.append("type", '2');
      let url = "/saveproduct";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchProducts();
        this.productname="";
        this.productprice="";
        this.category="";
        this.productdescrption="";
        this.productimage="";
        this.$bvModal.hide('new-product');
       }
      });
    },
    async addService(){
      let formData = new FormData();
      formData.append("name", this.productname);
      formData.append("price", this.productprice);
      formData.append("category", this.category);
      formData.append("description", this.productdescrption);
      formData.append("image", this.productimage);
      formData.append("type", '1');
      let url = "/saveproduct";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchServices();
        this.productname="";
        this.productprice="";
        this.category="";
        this.productdescrption="";
        this.productimage="";
        this.$bvModal.hide('new-service');
       }
      });
    },
    async editProduct(){
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("name", this.productname);
      formData.append("price", this.productprice);
      formData.append("category", this.category);
      formData.append("description", this.productdescrption);
      formData.append("image", this.productimage);
      let url = "/editproduct";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchProducts();
        this.$bvModal.hide('edit-product')
       }
      });
    },
    async removeProduct(){
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/deleteproduct";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchProducts();
        this.$bvModal.hide('delete-product')
       }
      });
    },
    async fetchOrders() { 
      let url = "/vendororders";
      await axios.get(url).then((response) => {
      if (response.status == 200) {
        this.orders=response.data.orders;
        this.updateCalendarEvents();
      }
    })
    },
    updateCalendarEvents() {
      this.calendarOptions.events = this.orders.map((order) => ({
        title: "Order: "+order.product.name+' - '+Number(order.quantity)*Number(order.product.price)+"<br> Client: " +order.client.first_name+' '+order.client.last_name+' - '+order.client.contact,
        start: order.order_date, 
      }));
    },
    async fetchBookings() { 
      let url = "/myorders";
      await axios.get(url).then((response) => {
      if (response.status == 200) {
        this.bookings=response.data.orders;
      }
    })
    },
    async approveOrder(){
      let formData = new FormData();
      formData.append("orderid", this.orderid);
      formData.append("approveddate", this.approveddate);
      formData.append("approvedtime", this.approvedtime);
      formData.append("approvedvenue", this.approvedvenue);
      let url = "/approveorder";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchOrders();
        this.$bvModal.hide('approve-order')
       }
      });
    },
  },
};
</script>